/**
 * Placeholder copy (CLAUDE.md rule 9): seed text wrapped in brackets, such as
 * `[Public-safe highlight]` or `[tagline]`, marks content that hasn't been
 * written yet. It renders as-is, styled as secondary text, and is never
 * replaced with invented content.
 */
export function isPlaceholder(text: string): boolean {
  return /^\[[^\]]+\]$/.test(text.trim());
}
